const documentUrl = document.currentScript.src.split('/');
const CONFIG = {
    TABLET_URL: process.env.TABLET_URL,
    DOCUMENT_URL: documentUrl,
    SCRIPT_HOSTNAME: new URL(documentUrl.join('')).hostname,
    BASE_URL: documentUrl[0] + '//' + documentUrl[2] + '/',
    DOMAIN: documentUrl[2],
    VISITOR_POWERED_BY_LINK: {
        VATANCOMPUTER: "663a324c03b195ef5bf18302", // Vatan Computer Site ID
    },
};
export default CONFIG;



//////////////////
// WEBPACK FOOTER
// ./static/src/config.js
// module id = null
// module chunks = 